const FuelCodesStatus = {
  Active: "active",
  Expired: "expired",
  Scheduled: "scheduled",
  Redeemed: "redeemed",
  Deactivated: "deactivated",
};

export default FuelCodesStatus;
